import React, { createContext } from "react";

const PredictionContext = createContext();

export default PredictionContext;